import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//Quinlan
import BaseMixer from "@/router/views/BaseMixer";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Loader from "@/components/widgets/loader.vue";
import USMap from "./USMap.vue";
import { DashboardModule } from "@/store/modules/dashboard.module";
let DashBoard = /** @class */ (() => {
    let DashBoard = class DashBoard extends Mixins(BaseMixer) {
        get clientDetail() {
            return DashboardModule.clientDetail;
        }
    };
    DashBoard = __decorate([
        Component({
            name: "ClientStatisticsComponent",
            components: {
                SectionLoader,
                Loader,
                USMap,
            },
        })
    ], DashBoard);
    return DashBoard;
})();
export default DashBoard;
